import {BaseFlagProps} from 'platform/components';
import {match} from 'ts-pattern';

import {always} from 'ramda';

import {GetInvoiceV4ApiResponse} from '@dms/api/core';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

type InvoiceCategory = GetInvoiceV4ApiResponse['invoiceCategory'] | Nullish;

export const getInvoiceCategoryFlagProps = (
  invoiceCategory: InvoiceCategory
): BaseFlagProps | null => {
  const flagProps = match<InvoiceCategory, BaseFlagProps | null>(invoiceCategory)
    .with('internal', always({label: i18n.t('general.labels.internal'), colorScheme: 'yellow'}))
    .with(
      'seller-as-supplier',
      always({label: i18n.t('general.labels.sellerAsSupplier'), colorScheme: 'purple'})
    )
    .otherwise(always(null));

  return flagProps;
};
